<template>
  <VRow no-gutters class="profile-row">
    <VCol v-if="label" cols="12" :class="['profile-label', isFocused && 'focused']">
      <span v-if="!$scopedSlots['infotext']" :class="[highContrast && 'high-contrast']" v-text="label" />
      <InfoBubble v-else>
        <span :class="[highContrast && 'high-contrast']" v-text="label" />
        <template #infotext>
          <slot name="infotext" />
        </template>
      </InfoBubble>
    </VCol>
    <VCol cols="12">
      <VAutocomplete
        class="m-autocomplete m-common"
        v-bind="$attrs"
        dense
        solo
        color="default"
        :loader-height="1"
        :filter="filterValue"
        hide-details="auto"
        :menu-props="{ ...menuProps, offsetY: true }"
        role="combobox"
        v-on="$listeners"
      >
        <template v-for="(_, name) in $slots" #[name]>
          <slot :name="name" />
        </template>
        <template v-for="(_, name) in $scopedSlots" #[name]="data">
          <slot :name="name" v-bind="data" />
        </template>
      </VAutocomplete>
    </VCol>
  </VRow>
</template>

<style lang="stylus">

</style>

<script lang="ts">
import type { PropType } from '@mimir/web/compat/vueCompat';
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VAutocomplete, VCol, VRow } from 'vuetify/lib';

type SelectFilter = 'contains' | 'startsWith';
export default defineComponent({
  name: 'MAutoComplete',
  components: {
    VAutocomplete,
    VCol,
    VRow,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
    highContrast: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: String as PropType<SelectFilter>,
      default: 'contains',
    },
    menuProps: {
      type: Object as PropType<Record<string, any>>,
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  methods: {
    filterValue(item: any, queryText: string, itemText: string): boolean {
      if (this.filter === 'startsWith') {
        return itemText.toLowerCase().startsWith(queryText.toLowerCase());
      }

      return itemText.toLowerCase().includes(queryText.toLowerCase());
    },
  },
});
</script>
